export const getPaidPartValue = (paid, totalPayment) => {
  const paidValue = paid ? parseFloat(paid) : 0;
  const totalPaymentValue = totalPayment ? parseFloat(totalPayment) : 0;
  const paidPart = totalPaymentValue ? paidValue / totalPaymentValue : 0;
  const paidPartPercent = paidPart ? (paidPart * 100).toFixed(2) : 0;
  return {
    paidPart,
    paidPartPercent: paidPartPercent ? [paidPartPercent, '%'].join(' ') : ''
  };
}